import { jsx as m, Fragment as C } from "react/jsx-runtime";
import { noop as a } from "lodash/fp";
import { useCallback as D, useMemo as T, useState as H } from "react";
import { onItemClick as N } from "./index.es2482.js";
import { MultiSelectDropdownMenuContextProvider as k } from "./index.es2487.js";
import { useEventRefresher as x, useReadableEventRefresher as y } from "@zdrbm/zdr-react";
import { useDropDownMenu as B } from "./index.es2488.js";
import { useMultiselectState as L } from "./index.es2489.js";
import { MultilineItem as O } from "./index.es85.js";
import { MenuListContainer as R } from "./index.es88.js";
const w = (r) => {
  const { index: o, style: t } = r, e = L();
  x(e.highlightedItems, e.autoFocus);
  const [[s]] = y(e.autoFocus), n = e.getItemByIndex(o), l = e.getItemByIndex(o + 1), [u, c] = H(), I = u - 1 !== o && o !== u;
  return n ? /* @__PURE__ */ m(
    O,
    {
      wrapperStyle: t,
      ...n,
      onClick: (d) => e.invokeItemSelected(n, d),
      autoFocus: s && o === 0,
      hasDivider: I && (n.hasDivider || !!l),
      onMouseEnter: n.isDisabled ? void 0 : () => c(o),
      onMouseLeave: n.isDisabled ? void 0 : () => c(void 0)
    },
    n.value
  ) : /* @__PURE__ */ m(C, {});
}, F = 78, b = 66, A = 62, W = 44, P = 42, G = 54;
function Z(r, o = !1) {
  var e;
  const t = r[0];
  return t != null && t.description ? (e = t.description) != null && e.toString().includes(`
`) ? F : t.thumbnail ? b : t.entityColor ? G : A : o ? W : P;
}
const $ = ({
  items: r,
  maxVisibleItems: o,
  onSelection: t = a,
  onItemSelection: e = a,
  searchTerm: s,
  NoResultsItem: n,
  selectionMode: l = "single",
  autoFocus: u = !1,
  disabledVirtualization: c,
  isUsingNewIconInfra: I = !1,
  testId: d,
  state: E,
  onItemsFiltered: M = a
}) => {
  const f = D(
    ({ item: i, e: S, multiselectState: v }) => {
      var p;
      N(
        v.highlightedItems.get(),
        i.value,
        l,
        e,
        t
      ), (p = i == null ? void 0 : i.onClick) == null || p.call(i, S);
    },
    [e, t, l]
  ), h = B({
    state: E,
    searchTerm: s,
    autoFocus: u,
    items: r,
    onItemClick: f,
    onItemsFiltered: M
  }), g = h.highlightedItems.get(), _ = T(
    () => Z(r, I),
    [I, r]
  );
  return /* @__PURE__ */ m(k, { multiSelectDropdownMenuState: h, children: /* @__PURE__ */ m(
    R,
    {
      itemHeight: _,
      itemCount: s ? g.length : r.length,
      maxVisibleItems: o,
      NoResults: n,
      disabledVirtualization: c,
      testId: d,
      children: w
    }
  ) });
};
export {
  P as BASE_ITEM_HEIGHT,
  F as DOUBLE_LINE_DESCRIPTION_SIZE,
  G as ITEMS_WITH_ENTITY,
  b as ITEM_WITH_THUMBNAIL,
  $ as MultilineDropdownMenu,
  w as MultilineWrapperItem,
  W as NEW_ICON_INFRA_BASE_ITEM_HEIGHT,
  A as ONE_LINE_DESCRIPTION_SIZE,
  Z as getMultilineDropdownMenuItemHeight
};
//# sourceMappingURL=index.es79.js.map
